
import Component from './component';
import createComponentFactory from '../createComponent';
import navGlobal from './navGlobal';
import { HeaderSearchActionType, NavActionType } from '../constant/actionType';
import headerSearch from './headerSearch';


class PageHeader extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.headerBar = element.querySelector('.js-pageHeader__bar');
    this.headerContent = element.querySelector('.js-pageHeader__content');
    this.headerObserver = new IntersectionObserver((changes) => {
      for(let change of changes) {

        if(change.isIntersecting) {
          this._unstickHeader();
        } else {
          this._stickHeader();
        }

      }
    }, {
      threshold: [0]
    });

    this.headerObserver.observe(this.headerBar);

    this._handleShowChildMenu = this._handleShowChildMenu.bind(this);
    this._handleHideChildMenu = this._handleHideChildMenu.bind(this);
    this._handleShowHeaderSearch = this._handleShowHeaderSearch.bind(this);
    this._handleHideHeaderSearch = this._handleHideHeaderSearch.bind(this);
    this._handleSearchExpanded = this._handleSearchExpanded.bind(this);
    this._handleSearchCollapsed = this._handleSearchCollapsed.bind(this);
  }

  _addEvents() {
    this.context.dispatcher.on(NavActionType.SHOW_CHILD_MENU, this._handleShowChildMenu);
    this.context.dispatcher.on(NavActionType.HIDE_CHILD_MENU, this._handleHideChildMenu);
    this.context.dispatcher.on(HeaderSearchActionType.SHOW_HEADER_SEARCH, this._handleShowHeaderSearch);
    this.context.dispatcher.on(HeaderSearchActionType.HIDE_HEADER_SEARCH, this._handleHideHeaderSearch);
    this.context.dispatcher.on('pcSearchExpanded', this._handleSearchExpanded);
    this.context.dispatcher.on('pcSearchCollapsed', this._handleSearchCollapsed);
  }

  _removeEvents() {
    this.context.dispatcher.off(NavActionType.SHOW_CHILD_MENU, this._handleShowChildMenu);
    this.context.dispatcher.off(NavActionType.HIDE_CHILD_MENU, this._handleHideChildMenu);
    this.context.dispatcher.off(HeaderSearchActionType.SHOW_HEADER_SEARCH, this._handleShowHeaderSearch);
    this.context.dispatcher.off(HeaderSearchActionType.HIDE_HEADER_SEARCH, this._handleHideHeaderSearch);
    this.context.dispatcher.off('pcSearchExpanded', this._handleSearchExpanded);
    this.context.dispatcher.off('pcSearchCollapsed', this._handleSearchCollapsed);
  }

  _handleSearchExpanded() {
    this.element.classList.add('is-search-expanded');
  }

  _handleSearchCollapsed() {
    this.element.classList.remove('is-search-expanded');
  }

  _handleShowChildMenu() {

    if(this._isChildMenuShown) {
      return;
    }

    this.element.dataset.active = 'navigation';
    this._isChildMenuShown = true;

  }

  _handleHideChildMenu() {
    this.element.removeAttribute('data-active');
    this._isChildMenuShown = false;
  }

  _handleShowHeaderSearch() {

    if(this.element.dataset.active) {
      this._handleHideChildMenu();
    }

  }

  _handleHideHeaderSearch() {

  }

  _stickHeader() {
    //this.headerContent.dataset.sticky = true;
  }

  _unstickHeader() {
    //delete this.headerContent.dataset.sticky;
  }

  didRegisterComponent() {
    this._addEvents();

    this.registerComponent('navGlobal', '.js-navGlobal', navGlobal);
    this.registerComponent('headerSearch', '.js-headerSearch', headerSearch);
  }

  didUnregisterComponent() {
    this._removeEvents();

    this.unregisterComponent('navGlobal');
    this.unregisterComponent('headerSearch');
  }
}


export default createComponentFactory(PageHeader);



// WEBPACK FOOTER //
// ./src/js/app/component/pageHeader.js